import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import useAuth from "src/hooks/useAuth";
import type { Notification } from "src/types/notification";
import { Query } from "src/types/query";
import type { User } from "src/types/user";
import axios from "src/utils/axios";

export const useQueryNotifications = (userProps?: {
    user: User;
}): UseQueryResult<Notification[], unknown> => {
    const { user: userAuth } = useAuth();
    const { user = userAuth } = userProps ?? {};

    return useQuery({
        queryKey: [Query.Notifications, user.id],
        queryFn: async () => {
            const result = await axios.get<{ notifications: Notification[] }>(`/notification`);
            return result.data.notifications;
        },
    });
};
